import React, { useEffect, useState } from "react";
import enUS from "../../../data/en-US";
import whiteLogo from '../../../assets/real_images/logo/logo-whitefont1.png'
import guardian1 from '../../../assets/real_images/guardian_1.png';
import guardian2 from '../../../assets/real_images/guardian_2.png';
import { useLanguageContext } from "../../../context/languageContext";
import Card01 from "../../cards/Card01";

const SliderSection = () => {

    const { language } = useLanguageContext();

    const [ data, setData ] = useState();

    const info = {
        'en-US': enUS
    }

    useEffect(() => {
        setData(info[language].homepage.slider)
    }, [])

    return (
        <div className="slider-section-wrapper themesflat-container">
            <div className="row">
                <div className="col-md-7">
                    <div className="slider-welcome-heading font-face-pop">
                        { data && data.heading }
                    </div>
                    <img src={whiteLogo} alt="Luncsphere" />
                    <div className="slider-welcome-body font-face-poppins">
                        { data && data.introduction_1.sentence}
                    </div>
                </div>
                <div className="col-md-5" style={{marginTop: `30px`, display: 'flex', justifyContent: 'end'}}>
                    <Card01 image={guardian1} direction={'right'}/>
                </div>
            </div>

            <div className="row mt-3 mb-5">
                <div className="col-md-5" style={{marginTop: `23px`}}>
                    <Card01 image={guardian2} direction={'left'}/>
                </div>
                <div className="col-md-1"></div>
                <div className="col-md-6">
                    <div className="slider-intro font-face-poppins">
                        { data && data.introduction_2.sentence.map((p, index) => (
                            <div key={index} className="slider-intro-section">
                                {p}
                            </div>
                        )) }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SliderSection;